export const getDefaultParameters = () => {
    const co_id = new URLSearchParams(window.location.search).get("co_id") ?? "";

    return { co_id };
};
